const EMOJI_REGEX = /\p{Extended_Pictographic}/gu;

export class EmojiHider {
  constructor() {
    this.enabled = false;
    this.originalNodes = new Map();
    this.observer = null;
  }

  enable() {
    if (this.enabled) {
      return;
    }
    this.enabled = true;
    this.scrubNode(document.body);
    this.observe();
  }

  disable() {
    if (!this.enabled) {
      return;
    }
    this.enabled = false;
    this.disconnect();
    for (const [node, original] of this.originalNodes.entries()) {
      if (node && node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = original;
      }
    }
    this.originalNodes.clear();
  }

  destroy() {
    this.disable();
  }

  observe() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => this.scrubNode(node));
      }
    });
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  scrubNode(rootNode) {
    if (!rootNode || !this.enabled) {
      return;
    }
    if (rootNode.nodeType === Node.TEXT_NODE) {
      this.scrubTextNode(rootNode);
      return;
    }
    if (rootNode.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const rootTag = rootNode.tagName?.toLowerCase();
    if (rootTag === "script" || rootTag === "style") {
      return;
    }

    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      this.scrubTextNode(textNode);
      textNode = walker.nextNode();
    }
  }

  scrubTextNode(textNode) {
    const original = textNode.nodeValue;
    if (!original || !EMOJI_REGEX.test(original)) {
      EMOJI_REGEX.lastIndex = 0;
      return;
    }
    EMOJI_REGEX.lastIndex = 0;
    if (!this.originalNodes.has(textNode)) {
      this.originalNodes.set(textNode, original);
    }
    textNode.nodeValue = original.replace(EMOJI_REGEX, "");
  }
}

